'use strict';

const { h } = require('phy');
const { WithI18n } = require('@grpn/preact-l10n');

const MerchantLogoImage = require('../.././modules/shared/views/merchants/merchant-logo-image');

function Thumbnail({ item, index, clickNavigation, routes }) {
  const advertUrl = item.merchantSlug
    ? routes.merchant.show.replace('{merchantSlug}', item.merchantSlug)
    : item.destination;

  return h(WithI18n, {}, i18n =>
    h(
      'a.navigation-item',
      {
        href: advertUrl,
        'aria-label': i18n.t('js.modules.shared.PaginationLinkAriaFormat', {
          0: 'carousel',
          1: item.merchantName,
        }),
        'data-bhc': `carousel-navigation:thumbnail-${item.merchantName}`,
        title: i18n.t('js.modules.shared.PaginationLinkAriaFormat', {
          0: 'carousel',
          1: item.merchantName,
        }),
        onClick: event => clickNavigation(event, index),
      },
      h(
        '.navigation-image',
        MerchantLogoImage({
          alt: `${item.merchantName} - ${item.offerCallout}`,
          data: item.media,
          size: ['w_68,h_68'],
          lazyload: false,
        })
      )
    )
  );
}

module.exports = Thumbnail;
